module.exports = __webpack_public_path__ + "img/fullscreen.528b1878.svg";